/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool,
    func,
    object, number,
} from 'prop-types';
import AddIcon from '@material-ui/icons/Add';
import Media from 'react-media';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import {
    Button, Dialog, DialogContent, DialogTitle,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ReactHtmlParser from 'react-html-parser';
import ClearIcon from '@material-ui/icons/Clear';
import { useDispatch } from 'react-redux';
import FoodDetailsExpansionPanel from '../../GraphqlFoodDetailsUI/v2/FoodDetailsExpansionPanel';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    icons: {
        position: 'absolute',
        right: '0px',
        top: '4px',
        '& svg': {
            width: '32px',
            height: '32px',
        },
    },
    removeIcon: {
        '& path:first-child': {
            fill: '#fff',
            opacity: 1,
        },
    },
    summaryRoot: {
        backgroundColor: 'inherit',
        minHeight: 37,
        padding: 0,
        fontSize: '18px',
        '&.Mui-expanded': {
            margin: 0,
            minHeight: 37,
        },
        '& .MuiExpansionPanelSummary-content': {
            margin: '0 10px',
        },
    },
    detailsRoot: {
        marginLeft: '0px',
        padding: '0px',
        fontSize: '14px',
        maxHeight: 312,
        overflow: 'auto',
        flexDirection: 'column',
        '& ul': {
            marginTop: 0,
            paddingLeft: '22px',
            '& li': {
                fontSize: 16,
            },
        },
    },
    label: {
        fontSize: 18,
        alignItems: 'center',
        textAlign: 'center',
        fontWeight: 600,
        color: '#2f2f2f',
    },
    summaryContent: {
        margin: '0px !important',
    },
    addonsVerification: {
        maxWidth: 950,
        borderRadius: 'inherit',
    },
    dialogContent: {
        display: 'flex',
        gap: '12px',
        '@media screen and (max-width: 600px)': {
            display: 'block',
        },
    },
    leftContainer: {
        width: '40%',
        padding: '25px 0px 0px',
        '@media screen and (max-width: 768px)': {
            padding: '15px 0px',
        },
        '@media screen and (max-width: 600px)': {
            width: '100%',
            padding: 0,
        },
        '& img': {
            width: '100%',
            height: 'auto',
        },
    },
    dialogHeader: {
        boxShadow: '0px 3px 3px rgb(47 47 47 / 15%)',
        padding: '10px 20px',
        '& h2': {
            display: 'flex',
            justifyContent: 'space-between',
        },
    },
    headerContent: {
        fontWeight: 700,
        fontSize: 20,
        letterSpacing: '0.01em',
        margin: 'auto 0',
        '@media screen and (max-width: 600px)': {
            fontSize: 16,
        },
    },
    closeIcon: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 'auto 0',
        float: 'right',
    },
    pannelRoot: {
        boxShadow: 'none',
        backgroundColor: 'inherit',
        margin: '0px !important',
        borderBottom: `2px solid ${theme.palette.cms?.productDetailsSummary || '#607767'}`,
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
            paddingBottom: '10px',
            borderBottom: `2px solid ${theme.palette.cms?.tertiary_hover}`,
        },
        [theme.breakpoints.up(768)]: {
            maxWidth: 650,
        },
    },
    productName: {
        fontSize: 24,
        paddingTop: 32,
        fontWeight: 600,
        '@media screen and (max-width: 768px)': {
            fontSize: 20,
            paddingTop: 16,
        },
    },
    price: {
        fontSize: 20,
        padding: '12px 0px',
        fontWeight: 600,
        '@media screen and (max-width: 768px)': {
            fontSize: 18,
        },
    },
    buttonContinue: {
        width: 280,
        backgroundColor: theme.palette.cms?.black || '#000000',
        color: 'white',
        float: 'right',
        textTransform: 'capitalize',
        fontSize: '16px',
        padding: '4px',
        borderRadius: 'inherit',
        '& svg': {
            display: 'flex',
            width: '0.7em',
            alignItems: 'center',
            marginLeft: '5px',
        },
        '@media screen and (max-width: 600px)': {
            marginTop: '15px',
            width: '100%',
            padding: '5px',
        },
        '&:hover': {
            backgroundColor: theme.palette.cms?.black || '#000000',
        },
    },
    rightContainer: {
        width: '60%',
        '@media screen and (max-width: 600px)': {
            width: '100%',
        },
    },
    buttonContainer: {
        width: '280px',
        backgroundColor: theme.palette.cms?.lightGreen || '#3f8d5c',
        color: theme.palette.cms?.white || '#ffffff',
        float: 'right',
        textTransform: 'capitalize',
        fontSize: 16,
        padding: '8px',
        borderRadius: 'inherit',
        '@media screen and (max-width: 600px)': {
            marginTop: 15,
            width: '100%',
            minHeight: 38,
        },
        '&:hover': {
            backgroundColor: theme.palette.cms?.lightGreen || '#3f8d5c',
        },
    },
    delButton: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        height: 20,
        '& .MuiIconButton-root': {
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        '& img': {
            width: '19px',
        },
        '& svg': {
            '&:focus': {
                outline: 'inherit',
            },
        },
    },
    addOnCount: {
        fontSize: 20,
    },
    addIcon: {
        fontSize: 28,
        '& svg': {
            width: '0.8em',
            display: 'flex',
        },
    },
    errorMessage: {
        color: theme.palette.cms?.errorMessage || '#DF3030',
        fontWeight: 400,
        fontSize: '15px',
        display: 'flex',
        alignItems: 'center',
        padding: '8px 16px',
        '& .MuiSvgIcon-root': {
            border: `1px solid ${theme.palette.cms?.errorMessage || '#DF3030'}`,
            borderRadius: '50%',
            width: '0.7em',
            height: '0.7em',
            padding: 2,
            marginRight: 6,
        },
        '@media screen and (max-width: 600px)': {
            fontSize: '12px',
            padding: '8px 1px',
            '& .MuiSvgIcon-root': {
                width: '0.5em',
                height: '0.5em',
            },
        },
    },
    buttonMainContainer: {
        display: 'flex',
        padding: '16px 0px 24px',
        justifyContent: 'end',
        '@media screen and (max-width: 600px)': {
            display: 'block',
            paddingTop: '0px',
        },
    },
    dialogContentContainer: {
        padding: '8px 32px',
    },
});

const AddonModal = ({
    classes,
    selectedOption,
    open,
    handleIncrement,
    handleDecrement,
    setOpen,
    matchAddons,
    handleQuantity,
    error,
    isPdpRedesignEnabled,
}) => {
    const dispatch = useDispatch();
    const buildImgPath = (path, name) => `${path + name}x.jpg?width=354&height=358&auto=webp`;
    return (
        <Dialog
            PaperProps={{
                className: classes.addonsVerification,
            }}
            open={open}
            maxWidth="xs"
            onClose={() => { setOpen(false); }}
        >
            <DialogTitle className={classes.dialogHeader}>
                <span className={classes.headerContent}>PRODUCT DETAILS</span>
                <span role="presentation" onClick={() => { setOpen(false); }}>
                    <CloseIcon className={classes.closeIcon}  />
                </span>
            </DialogTitle>
            <DialogContent data-testid="producty-detail-content" className={classes.dialogContentContainer}>
                <div className={classes.dialogContent}>
                    <div className={classes.leftContainer}>
                        <img className={classes.imageWine} src={buildImgPath(selectedOption?.image?.path, selectedOption?.image?.name)} width="322" height="358" alt="addOns" />
                    </div>
                    <div className={classes.rightContainer}>
                        <Typography className={classes.productName}>{ReactHtmlParser(selectedOption?.name)}</Typography>
                        <Typography className={classes.price}>$ {selectedOption?.prices?.[0].value}</Typography>
                        {selectedOption?.longDescription &&  <FoodDetailsExpansionPanel summary="Contents" details={ReactHtmlParser(selectedOption.longDescription)} panelId={1} expanded={!selectedOption.shortDescription}  classes={classes} pdpInlineAddon />}
                        {selectedOption?.shortDescription && <FoodDetailsExpansionPanel summary="Description" details={ReactHtmlParser(selectedOption.shortDescription)} panelId={2}  expanded={selectedOption.shortDescription} classes={classes} pdpInlineAddon />}
                    </div>
                </div>
                <div className={classes.buttonMainContainer}>
                    <Media query="(min-width: 600px)">
                        { error && (
                            <div className={classes.errorMessage}>
                                {isPdpRedesignEnabled ? <div>You’ve reached the maximum number of extras</div> : <><ClearIcon /> <div> You have added the maximum of Extras allowed</div></>}
                            </div>
                        )}

                    </Media>
                    {!matchAddons(selectedOption?.id) ?  (
                        <Button
                            color="primary"
                            id="btnAddToCart"
                            data-testid="btn-add-to-cart"
                            className={`${classes.buttonContinue} `}
                            onKeyDown={() => {}}
                            tabIndex={-1}
                            role="button"
                            onClick={() => {
                                handleIncrement(selectedOption);
                                dispatch(trackEvent({
                                    eventCategory: 'Inline Addons',
                                    eventAction: 'Added Item',
                                    eventLabel: selectedOption?.id || '',
                                }));
                            }}
                        >
                            Add  <AddIcon />
                        </Button>
                    ) : (
                        <Button
                            color="primary"
                            id="btnAddToCart"
                            data-testid="remove-icon"
                            className={`${classes.buttonContainer} `}
                            tabIndex={-1}
                        >
                            <span className={classes.delButton}>
                                <IconButton
                                    className={classes.deleteIcon}
                                    onClick={() => {
                                        handleDecrement(selectedOption);
                                        dispatch(trackEvent({
                                            eventCategory: 'Inline Addons',
                                            eventAction: 'Removed Item',
                                            eventLabel: selectedOption?.id || '',
                                        }));
                                    }}
                                    onKeyDown={() => {}}
                                    tabIndex={-1}
                                    role="button"
                                >
                                    <img src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt8803188c991cd120/632ae23d8966566ecdfbe08e/delete.svg?auto=webp"  alt="Remove Logo" />
                                </IconButton>
                                <span className={classes.addOnCount}>{handleQuantity(selectedOption)}</span>
                                <span
                                    className={classes.addIcon}
                                    onKeyDown={() => {}}
                                    tabIndex={-1}
                                    role="button"
                                    onClick={() => {
                                        handleIncrement(selectedOption);
                                        dispatch(trackEvent({
                                            eventCategory: 'Inline Addons',
                                            eventAction: 'Added Item',
                                            eventLabel: selectedOption?.id || '',
                                        }));
                                    }}
                                > <AddIcon />
                                </span>
                            </span>
                        </Button>
                    )}
                    <Media query="(max-width: 600px)">
                        {error && (
                            <div className={classes.errorMessage}>
                                {isPdpRedesignEnabled ? <div>You’ve reached the maximum number of extras</div> : <><ClearIcon /> <div> You have added the maximum of Extras allowed</div></>}
                            </div>
                        )}
                    </Media>
                </div>
            </DialogContent>
        </Dialog>
    );
};
AddonModal.propTypes = {
    classes: object.isRequired,
    selectedOption: object.isRequired,
    setOpen: func.isRequired,
    open: bool,
    handleIncrement: func.isRequired,
    handleDecrement: func.isRequired,
    matchAddons: bool,
    handleQuantity: number,
    error: bool,
    isPdpRedesignEnabled: bool,
};
AddonModal.defaultProps = {
    handleQuantity: 0,
    open: false,
    matchAddons: false,
    error: false,
    isPdpRedesignEnabled: false,
};
export default (withStyles(styles)(AddonModal));
